import React from 'react'
import { ActorDetailFormReadOnly } from '@EUForms/parties/actorDetailFormReadOnly'
import List from '@commonComponents/List'
import { Accordion, AccordionItem } from '@commonComponents/accordion'
import CommonActorDetailHeader from '@EUForms/parties/commonActorDetailHeader'
const partiesLabel = {
    buyer: { title: "buyer", tableName: "buyersList", boxNumber: "3/26" },
    seller: { title: "seller", tableName: "sellersList", boxNumber: "3/24" },
}
const EuParties = ({ translate, buyers, sellers }) => {

    const renderItem = (tableName) => (item) => <ActorDetailFormReadOnly
        key={item?.id}
        translate={translate}
        tableName={tableName}
        dataSource={item}
    />

    return (
        <div>
            <div style={{ textAlign: 'center',textTransform:'uppercase' }}>
                {translate('PARTIES', { ns: ['default', 'valueBuildUp'] })}
            </div>
            <div>
                <Accordion translate={translate}>
                    <AccordionItem id="1" title={(props) => (
                        <CommonActorDetailHeader name={buyers?.[0]?.name} {...props} translate={translate} {...partiesLabel.buyer} />)}>
                        {/* <div>{translate('BUYER', { ns: ['default', 'valueBuildUp'] })}</div> */}
                        <List
                            className="responsiveGridCss"
                            dataSource={buyers}
                            renderItem={renderItem(partiesLabel.buyer.tableName)} />
                    </AccordionItem>
                    <AccordionItem id="2" title={(props) => (
                        <CommonActorDetailHeader name={sellers?.[0]?.name} {...props} translate={translate} {...partiesLabel.seller} />)}>
                        {/* <div>{translate('SELLER', { ns: ['default', 'valueBuildUp'] })}</div> */}
                        <List
                            className="responsiveGridCss"
                            dataSource={sellers}
                            renderItem={renderItem(partiesLabel.seller.tableName)} />
                    </AccordionItem>
                </Accordion>
            </div>
        </div>
    )
}

export default EuParties